import {FC, useCallback, useEffect, useMemo, useReducer, useState} from 'react'
import {ActionType, initialState, paginateReducer, PaginationInterface} from './types'
import {useHistory} from 'react-router-dom'

const Pagination: FC<PaginationInterface> = ({
                                               itemsPerPage,
                                               totalItems,
                                               setCurrentPage,
                                               setItemsPerPage,
                                             }) => {
  const {location: {pathname}} = useHistory()
  const isPathSpecial = useMemo(() => ['/referencement-naturel'].includes(pathname), [pathname])

  const [state, dispatch] = useReducer(paginateReducer, initialState)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)

  const pageNumbers = useMemo(() => {
    const totalPages = Math.ceil(totalItems / itemsPerPage)
    return Array.from({length: totalPages}, (_, i) => i + 1)
  }, [totalItems, itemsPerPage])

  const handlePageChange = useCallback((newPage: number) => {
    setCurrentPage(newPage)
    dispatch({type: ActionType.SET, payload: newPage})
  }, [setCurrentPage])

  useEffect(() => {
    if (pageNumbers.length && state.counter > pageNumbers.length) {
      handlePageChange(pageNumbers.length)
    }
  }, [pageNumbers.length, state.counter, handlePageChange])

  const handleItemsPerPageChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = parseInt(event.target.value)
    setRowsPerPage(newItemsPerPage)
    setItemsPerPage(newItemsPerPage)
  }, [setItemsPerPage])

  return totalItems >= 10 ? (
    <div className="row d-flex justify-content-end align-items-center mt-3">
      <div
        className={`d-flex justify-content-end align-items-center ${isPathSpecial ? 'col-5 col-sm-3 col-md-4' : 'col-5 col-sm-3 col-xl-2'}`}>
        <select
          className="form-select form-select-sm form-select-solid user-select-none"
          value={rowsPerPage}
          onChange={handleItemsPerPageChange}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
      </div>
      <div
        className={`d-flex justify-content-end align-items-center ${isPathSpecial ? 'col-7 col-md-8' : 'col-5 col-xl-2 col-sm-3'}`}>
        <ul className="pagination">
          <li className="page-item previous">
            <button className={`page-link ${state.counter === 1 ? 'invisible' : ''}`}
                    onClick={() => handlePageChange(state.counter - 1)}
                    disabled={state.counter === 1}
            >
              <i className="previous" />
            </button>
          </li>
          <li className="page-item active user-select-none">
            <span className="page-link">{state.counter}</span>
          </li>
          <li className="page-item next">
            <button className={`page-link ${state.counter === pageNumbers.length ? 'invisible' : ''}`}
                    onClick={() => handlePageChange(state.counter + 1)}
                    disabled={state.counter === pageNumbers.length}
            >
              <i className="next" />
            </button>
          </li>
        </ul>
      </div>
    </div>
  ) : null
}

export {Pagination}
